import { useTranslation } from 'react-i18next';
import { useAllTalentAgencyOrPartnerOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const TalentAgencyPartnerField = (
  props: Omit<MultipleSelectorFieldProps<InfluencersFilterFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allTalentAgencyPartnerOptions } = useAllTalentAgencyOrPartnerOptions();

  return (
    <SelectorField<InfluencersFilterFormKeys>
      name="talentAgencyOrPartnerIds"
      title={t('Selector.Partner & Talent Agency')}
      options={allTalentAgencyPartnerOptions}
      multiple
      {...props}
    />
  );
};
